import { Column } from "primereact/column";
import { Skeleton } from "primereact/skeleton";
import { DataTable } from "../../components/data/DataTable";
import { Link, useNavigate } from "react-router-dom";
import { ScheduleResponse } from "../../models/dtos";
import { Button } from "primereact/button";
import { ConfirmPopup, confirmPopup } from "primereact/confirmpopup";
import Error from "../../components/common/Error";
import { useSelector } from "react-redux";
import { getScheduleFilters } from "../../services/schedule/scheduleSlice";
import { Toolbar } from "primereact/toolbar";
import { useEffect, useRef, useState } from "react";
import { useAppDispatch } from "../../hooks/redux";
import { setContextSidebar } from "../../services/base/layoutSlice";
import { Toast } from "primereact/toast";
import { scheduleApi } from "../../services/schedule/scheduleApi";

const SchedulesList = () => {
  const scheduleFilters = useSelector(getScheduleFilters);
  const dispatch = useAppDispatch();
  const [loading, setLoading] = useState(false);
  const toast = useRef<Toast>(null);
  const dt = useRef<any>(null);
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(setContextSidebar(true));

    return () => {
      dispatch(setContextSidebar(false));
    };
  }, [dispatch]);

  const {
    data: schedules,
    error,
    isLoading,
  } = scheduleApi.useGetSchedulesQuery({
    byFaculty: scheduleFilters.faculties.map((x) => ({
      id: x.facultyId,
    })),
    bySpeciality: scheduleFilters.specialities.map((x) => ({
      id: x.specialityId,
    })),
  });

  // const [createSchedule] = scheduleApi.useCreateScheduleFromCopyMutation();
  const [deleteSchedule] = scheduleApi.useDeleteScheduleMutation();

  const scheduleCodeTemplate = (rowData: ScheduleResponse) => {
    return (
      <div className="flex align-items-center justify-content-between">
        <span>{rowData.planId}</span>
        <Link to={`/schedule/${rowData.scheduleId}`}>
          <Button icon="pi pi-calendar"></Button>
        </Link>
      </div>
    );
  };

  const handleExport = () => {
    if (dt.current) {
      dt.current.exportCSV({ selectionOnly: true });
    }
  };

  // const createScheduleFromCopy = async (scheduleId: number) => {
  //   setLoading(true);
  //   try {
  //     const response = await createSchedule(scheduleId).unwrap();
  //     setLoading(false);
  //     navigate(`/schedule/${response.data}`);
  //   } catch (error) {
  //     setLoading(false);
  //     toast?.current?.show({ severity: "error", summary: "Грешка", detail: "Възникна грешка" });
  //   }
  // };

  // const renderCreateScheduleButton = (rowData: ScheduleResponse) => (
  //   <Button
  //     label=""
  //     icon="pi pi-plus"
  //     onClick={() => {
  //       createScheduleFromCopy(rowData.scheduleId);
  //     }}
  //     disabled={loading}
  //   />
  // );

  const handleDeleteSchedule = async (scheduleId: number) => {
    setLoading(true);
    try {
      const response = await deleteSchedule(scheduleId).unwrap();
      if (response.data.result === true) {
        toast.current?.show({ severity: "success", summary: "Изтриване", detail: "Учебното разписание е изтрито." });
      } else {
        toast?.current?.show({
          severity: "error",
          summary: "Грешка",
          detail: "Възникна грешка по време на изтриването.",
        });
      }
    } catch (error) {
      toast?.current?.show({
        severity: "error",
        summary: "Грешка",
        detail: "Възникна грешка по време на изтриването.",
      });
    } finally {
      setLoading(false);
    }
  };

  const confirmDelete = (event: React.MouseEvent<HTMLElement>, item: number) => {
    confirmPopup({
      target: event.currentTarget as HTMLElement,
      message: "Сигурни ли сте, че искате да изтриете този запис?",
      icon: "pi pi-info-circle",
      defaultFocus: "reject",
      acceptClassName: "p-button-danger",
      acceptLabel: "Да",
      rejectLabel: "Не",
      accept: () => handleDeleteSchedule(item),
    });
  };

  const renderDeleteScheduleButton = (rowData: ScheduleResponse) => (
    <Button
      label=""
      icon="pi pi-trash"
      className="p-button-danger"
      onClick={(e) => confirmDelete(e, rowData.scheduleId)}
      disabled={loading}
    />
  );

  const topButtons = (
    <>
      <Button
        label="Добави разписание"
        icon="pi pi-plus"
        severity="success"
        onClick={() => navigate("/schedule/create")}
      />
    </>
  );

  const extraButtons = (
    <>
      <Button label="Експорт CSV" icon="pi pi-upload" severity="secondary" onClick={handleExport} />
    </>
  );

  if (isLoading) return <Skeleton className="w-full h-2rem" />;
  if (error) return <Error error={error} />;

  return (
    <div className="sticky top-0">
      <h1 className="mb-4 mt-0 text-4xl font-light">Учебни разписания</h1>
      <Toolbar start={topButtons} end={extraButtons} />
      <ConfirmPopup />
      <Toast ref={toast} />
      <DataTable ref={dt} value={schedules?.data ?? []} emptyMessage="Не бяха открити планове.">
        <Column field="schedule" header="ID" body={scheduleCodeTemplate} sortable filter></Column>
        <Column field="specialityName" header="Специалност" sortable filter></Column>
        <Column
          field="isSession"
          header="Тип разписание"
          sortable
          filter
          body={(rowData) => (rowData.isSession ? "Сесийно" : "Семестриално")}
        ></Column>
        <Column field="startDate" header="Начална дата семестър" sortable filter></Column>
        <Column field="endDate" header="Крайна дата семестър" sortable filter></Column>
        <Column
          field="isPublished"
          header="Публикувано"
          sortable
          filter
          body={(rowData) => (rowData.isPublished ? "Да" : "Не")}
        ></Column>
        {/* <Column body={renderCreateScheduleButton} header="Създай от копие"></Column> */}
        <Column body={renderDeleteScheduleButton} header="Изтрий разписание"></Column>
      </DataTable>
    </div>
  );
};

export default SchedulesList;
